import React from 'react';
import PropTypes from 'prop-types';

class Btn extends React.Component {
  getVariantCss(variant, isActive) {
    const base = 'group transition ease-in duration-200 inline-flex items-center outline-none focus:outline-none';
    const btnClass = 'border py-2 px-4 ';
    switch (variant) {
      case 'link':
        return 'mx-1 font-bold text-primary-500 uppercase place-self-center hover:underline hover:text-primary-300';
      case 'primary':
        return `${isActive ? 'bg-primary-500' : 'border-primary-500 text-primary-500'} ${btnClass} ${base}`;
      case 'primary-solid':
        return `${isActive ? 'bg-primary-500' : 'bg-primary-500'} text-white ${btnClass} ${base}`;
      case 'cancel':
        return `${isActive ? 'bg-red-500' : 'border-red-500 text-red-500'} ${btnClass} ${base}`;
      default:
        return base;
    }
  }

  render() {
    const {
      className, children, onClick, onFocus, disabled, variant, href, onBlur, type,
    } = this.props;
    if (href) {
      return (
              <a href={href}
                 className={`${className || ''} ${this.getVariantCss(variant)}`}>
                {children}
              </a>
      );
    }
    const isButton = onClick || type === 'submit' || type === 'button';
    if (isButton) {
      return (
              <button
                      disabled={disabled}
                      onClick={onClick}
                      onFocus={onFocus}
                      onBlur={onBlur}
                      className={`${className || ''} ${variant || ''} ${this.getVariantCss(variant)}`}>
                {children}
              </button>
      );
    }
    return (
            <span className={`${className || ''} ${this.getVariantCss(variant)}`}>
        {children}
      </span>
    );
  }
}

Btn.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Btn;
